import { useEffect } from "react";

// React renders its own `[data-toggle="tooltip"]` and `[data-bind="popover"]` nodes, which the
// page-wide widgets cannot know about. The components used to call `Widgets.Tooltip.reload()` /
// `Widgets.Popover.reload()` for that, and a reload is a *page-wide* teardown and re-init: with N
// members in the schedule sidebar it ran N times per render, and it closed any tooltip or popover
// the user happened to have open elsewhere on the page.
//
// These hooks attach and detach the plugin on the one node the component owns instead. The widget
// stays the single implementation -- notably `Widgets.Popover` keeps its delayed ajax show/hide,
// which the server-rendered popovers use too.
const useOverlay =
  (widgetName) =>
  (ref, deps = []) => {
    useEffect(() => {
      const node = ref.current;
      const widget = window.Widgets?.[widgetName];
      if (!node || !widget) return undefined;

      widget.enableOn(node);

      return () => widget.cleanupOn(node);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref, ...deps]);
  };

export const useBootstrapTooltip = useOverlay("Tooltip");
export const useBootstrapPopover = useOverlay("Popover");
